import script from "./OrderQuestionComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderQuestionComponent.vue?vue&type=script&lang=ts&setup=true"

import "./OrderQuestionComponent.vue?vue&type=style&index=0&id=241cc2ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-241cc2ca"]])

export default __exports__